@use 'vars';

.iq-refine-menu {
  display: flex;
  flex-direction: column;

  &--empty-text {
    font-size: vars.$font-size-small;
    padding-bottom: vars.$padding-xsmall;
  }

  &--stand_alone {
    gap: vars.$gap-small;
    padding: 0 vars.$padding-large;
  }
}
